import * as connectionsApi from '../api';
import {
  IAuthorizeFivetranConnectionResponseData,
  ICancelConnectionRequestData,
  ICreateAdverityConnectionRequestData,
  ICreateFivetranConnectionRequestData,
  ICreateFivetranConnectionResponseData,
  IGetAdverityAvailablePlatformsResponseData,
  IGetAdverityConnectionTypesResponseData,
  IGetAuthorizedConnectionResponseData,
  IGetConnectionLinkedAccountResponseData,
  IGetFivetranConnectionsResponseData,
  IGetFivetranConnectionTypesResponseData,
  IUnlinkConnectionRequestData,
} from '../types';

export const getConnectionTypes =
  async (): Promise<IGetAdverityConnectionTypesResponseData> =>
    connectionsApi.getConnectionTypes();

export const getListOfAvailablePlatforms =
  async (): Promise<IGetAdverityAvailablePlatformsResponseData> =>
    connectionsApi.getListOfAvailablePlatforms();

export const getConnectionsLinkedAccount = async (
  linkedAccountId: string
): Promise<IGetConnectionLinkedAccountResponseData> =>
  connectionsApi.getConnectionsLinkedAccount(linkedAccountId);

export const createConnection = async (
  data: ICreateAdverityConnectionRequestData
): Promise<string> => connectionsApi.createConnection(data);

export const cancelConnection = async (
  data: ICancelConnectionRequestData
): Promise<void> => connectionsApi.cancelConnection(data);

export const authorizeConnection = async (
  linkedAccountId: string
): Promise<IGetAuthorizedConnectionResponseData> =>
  connectionsApi.authorizeConnection(linkedAccountId);

export const unlinkAccount = async (
  data: IUnlinkConnectionRequestData
): Promise<void> => connectionsApi.unlinkAccount(data);

export const createFivetranConnection = async ({
  data,
  customerId,
}: ICreateFivetranConnectionRequestData): Promise<ICreateFivetranConnectionResponseData> =>
  connectionsApi.createFivetranConnection({ customerId, data });

export const deleteFivetranConnection = async (
  connectionId: string
): Promise<void> => connectionsApi.deleteFivetranConnection(connectionId);

export const authorizeFivetranConnection = async (
  connectionId: string
): Promise<IAuthorizeFivetranConnectionResponseData> =>
  connectionsApi.authorizeFivetranConnection(connectionId);

export const getFivetranConnections = async (
  customerId?: string
): Promise<IGetFivetranConnectionsResponseData> =>
  connectionsApi.getFivetranConnections(customerId);

export const getFivetranConnectionTypes =
  async (): Promise<IGetFivetranConnectionTypesResponseData> =>
    connectionsApi.getFivetranConnectionTypes();
